import { Dispatch } from 'redux'

import { setWindowLocation } from './actionCreators'

export const setWindowLocationFlow = (location: string) => (
  dispatch: Dispatch,
) => dispatch(setWindowLocation(location))
